<h1 mat-dialog-title>{{ 'DIALOGS.ASSOCIATION.title' | translate }}</h1>
<mat-dialog-content style="padding-bottom: 10px">
  <mat-list>
    @for (association of associations; track association) {
      <mat-list-item>
        {{association.courier.name}}: {{association.isAssociated ? ('DIALOGS.ASSOCIATION.present' | translate) : ('DIALOGS.ASSOCIATION.absent' | translate)}}
      </mat-list-item>
    }
  </mat-list>
  <div style="font-style: italic">
    <p>{{ 'DIALOGS.ASSOCIATION.warning' | translate }}</p>
    <p>{{ 'DIALOGS.ASSOCIATION.contact_admin' | translate }}</p>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button [mat-dialog-close]="interruptResult" color="warn" mat-raised-button>{{ 'COMMON.cancel' | translate }}</button>
  <button [mat-dialog-close]="resumeResult" color="primary" mat-raised-button>{{ 'COMMON.continue' | translate }}</button>
</mat-dialog-actions>
